import * as z from "zod";

/** Attributed orders for one marketing entity, in the team's own currency.
 *  Orders in another currency are excluded from both numbers. */
export const attributedMetricSchema = z.object({
  revenue: z.number(),
  orders: z.number(),
});
export type AttributedMetric = z.infer<typeof attributedMetricSchema>;

/** Attributed order metrics keyed by the grouped scope's id (campaign id, etc.). */
export const attributionSchema = z.record(z.string(), attributedMetricSchema);
export type Attribution = z.infer<typeof attributionSchema>;
